import { render, staticRenderFns } from "./CuponeraComponent.vue?vue&type=template&id=fbc4b7c2&"
import script from "./CuponeraComponent.vue?vue&type=script&lang=js&"
export * from "./CuponeraComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports